import { createFileRoute } from '@tanstack/react-router'

import { AssetDetail } from '@/pages/AssetLibrary/AssetDetail'

export const Route = createFileRoute(
  '/_app/asset-library/$packageId/$assetId/',
)({
  component: AssetDetailRoute,
})

function AssetDetailRoute() {
  const { packageId, assetId } = Route.useParams()
  return <AssetDetail packageId={packageId} assetId={assetId} />
}
